export default "__VITE_ASSET__Dp$6k1VN__"